/*
function isEmail(email) {
    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}
*/

$(document).ready(function(){
    $('a[href="#"]').click(function(e){
        e.preventDefault();
    });

    $('.js-add-text-to-clipboard').click(function(){
        let text = $.trim($(this).text());
        let $temp = $('<input>');
        let notif_text = $(this).data('notif-text');
        if(notif_text == undefined){
            notif_text = 'Text bol skopírovaný do schránky';
        }
        $('body').append($temp);
        $temp.val(text).select();
        document.execCommand('copy');
        $temp.remove();
        notif('success', notif_text);
    });
});
